module.exports = __webpack_public_path__ + "img/image_gallery9.5d1010fd.jpg";